import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import type { LabelListItem } from '~settings/api/lib/schemas';
import type { LabelListQueryVariables } from '~settings/api/queries/labelList';
import { useLabelList } from '~settings/api/queries/labelList';
import { Table } from '~settings/components/Table';
import { SETTINGS_ROUTES } from '~settings/config/routes';
import { usePagination } from '~settings/hooks/usePagination';

import { ListControls } from '../components/ListControls';
import { useLabelsColumns } from './useLabelsColumns';

const emptyLabels: LabelListItem[] = [];
const TEMP_HARDCODED_VARIABLES: LabelListQueryVariables = {
  skip: 0,
  take: 50,
};

const enum LabelType {
  PARENT_LABEL = 'Parent labels',
  SUBLABEL = 'Sublabels',
}

export const Labels = () => {
  const { isLoading, isError, labelList } = useLabelList(
    TEMP_HARDCODED_VARIABLES,
  );
  const { t } = useTranslation('settings');
  const { page, handlePageChange, perPage } = usePagination();

  const columns = useLabelsColumns();
  const [activeOption, setActiveOption] = useState<boolean | null>(null);

  const navigate = useNavigate();
  const onClick = (row: LabelListItem) => {
    navigate(SETTINGS_ROUTES.LABEL_DETAIL(row.id));
  };

  if (isLoading) {
    return <section className="py-md">Loading...</section>;
  }

  if (isError) {
    // eslint-disable-next-line i18next/no-literal-string
    return <section className="py-md">Something went wrong.</section>;
  }

  return (
    <>
      <ListControls
        placeholder={t('searchLabels')}
        options={[LabelType.PARENT_LABEL, LabelType.SUBLABEL]}
        filterType={'labelType'}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        page={page}
        total={labelList?.total ?? 0}
        perPage={perPage}
        entity="labels"
        handlePageChange={handlePageChange}
      />
      <Table
        data={labelList?.data ?? emptyLabels}
        columns={columns}
        onRowClick={onClick}
      />
    </>
  );
};
Labels.displayName = 'Labels';
